<template>
  <side-bar-page :dataProps="{showUp: true,percentShow: 0}">
    <template slot="content">
      <div class="content content-m">
        <b-tabs content-class="mt-3 container-fluid" class="rating-tab">
          <b-tab class="uppercase" :title="$t('bb_tab_1')" active>
            <bb-job-ads></bb-job-ads>
          </b-tab>
          <b-tab class="uppercase" :title="$t('bb_tab_2')">
            <bb-my-posts></bb-my-posts>
          </b-tab>
        </b-tabs>
      </div>
    </template>
  </side-bar-page>
</template>

<script>
  import SideBarPage from '../components/SideBarPage'
  import BbJobAds from '../components/BB_JobAds'
  import BbMyPosts from '../components/BB_MyPosts'

  export default {
    name: 'bulletinBoard',
    components: { SideBarPage, BbJobAds, BbMyPosts },
  }
</script>

<style scoped>
.content {
  min-height: 100%;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 25px;
  background-color:#F7F7F8 !important;
}
@media only screen and (max-width: 768px) {
  .content {
    padding-top: 10px !important;
  }
}
</style>

<style>
.nav-tabs .nav-link, .nav-tabs .nav-item.show .nav-link {
  text-transform: uppercase !important;
}
</style>